/**
 * Dropdown component for navigation menus
 */

import React, { useState, ReactNode } from 'react';
import './Dropdown.css';

interface DropdownProps {
    label: string;
    className?: string;
    children: ReactNode;
}

export default function Dropdown({ label, className = '', children }: DropdownProps) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className={`dropdown ${className}`}
            onMouseLeave={() => setIsOpen(false)}
            onMouseEnter={() => setIsOpen(true)}
        >
            <button
                className={`dropdownTrigger ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                onMouseEnter={() => setIsOpen(true)}
            >
                {label}
            </button>
            <div
                className="dropdownContent"
                style={{ display: isOpen ? 'block' : 'none' }}
            >
                {children}
            </div>
        </div>
    );
}
